<template>
	<div>
		<el-empty description="目前还没有内容噢～" v-if="tableData.length==0">
			<div slot="image">
				<img src="../../assets/index/empty.png" />
			</div>
		</el-empty>
		<div class="db-content" v-else>
			<el-table :data="tableData" :header-cell-style="headerCellStyle" stripe style="width: 100%">
				<el-table-column prop="title" label="标题" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-link @click="handleShow(scope.row)">{{scope.row.title}}</el-link>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" width="110" align="right" label="发布时间">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		name: "XxglNotice",
		data() {
			return {
				title: "",
				openDialog1: false,
				xwylcontent: null,
				tableData: [],
				form: {},
				openDialog: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 40, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						ggzt: "0",
					}
				},
			};
		},
		created() {
		},
		methods: {

			async getList() {
				let _this = this;
				const {
					data: res
				} = await xxglNoticeList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				}
			},
			formatStatus: function(row) {
				return row.ggzt == 0 ? '是' : '否';
			},
			formatTop: function(row) {
				return row.sfzd == 0 ? '是' : '否';
			},
			xwContentFun: function(data) {
				this.form.ggnr = data;
			},
			handleShow: function(data) {
				this.openDialog1 = true;
				this.xwylcontent = data;
			},
		}
	};
</script>
<style scoped="scoped">
	.db-content {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 5px 0px;
		cursor: pointer;
	}

	.db-class {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: linear-gradient(45deg, rgb(28, 187, 180), rgb(141, 198, 63));
		line-height: 40px;
		text-align: center;
		color: #FFFFFF;
		margin-right: 10px;
		font-size: 20px;
	}

	.db-body {
		display: flex;
		flex-direction: column;
		display: 24px;
	}

	.db-time {
		margin-left: auto;
	}
</style>
